import { createContext, useContext } from 'react';
import type * as Y from 'yjs';

export const CanvasDocContext = createContext<Y.Doc | null>(null);

export function useCanvasDoc(): Y.Doc | null {
  return useContext(CanvasDocContext);
}
